import { BridgeStatus } from '../../hooks/useBridgeStatus';

export const bgStatusColors: Record<BridgeStatus['status'], string> = {
  open: 'bg-green-200',
  warning: 'bg-yellow-200',
  closed: 'bg-red-300',
  unknown: 'bg-neutral-200',
};

export const bgStatusTexts: Record<BridgeStatus['status'], string> = {
  open: 'bridgeStatus.open',
  warning: 'bridgeStatus.warning',
  closed: 'bridgeStatus.closed',
  unknown: 'bridgeStatus.unknown',
};
export const bgStatusTextColors: Record<BridgeStatus['status'], string> = {
  open: 'text-green-800',
  warning: 'text-notice-600',
  closed: 'text-red-700',
  unknown: '',
};
export const bgStatusBorderColors: Record<BridgeStatus['status'], string> = {
  open: 'border-green-800',
  warning: 'border-yellow-300',
  closed: 'border-red-700',
  unknown: 'border-neutral-400',
};
